const DONE_STATUS_TYPES = ["done", "complete", "completed", "close", "closed"];

function validateRecurrence(startValue, recurrence = {}) {
    if (!recurrence.enabled) return true;

    const start = new Date(startValue);
    const interval = Number(recurrence.interval);

    if (Number.isNaN(start.getTime())) return false;
    // "Recur forever" has no end date; otherwise the end date must not be before the due date
    if (!recurrence.forever) {
        const until = new Date(recurrence.until);
        if (Number.isNaN(until.getTime()) || until < start) return false;
    }
    if (!Number.isInteger(interval) || interval < 1 || interval > 30) return false;
    if (!["day", "week", "month", "year"].includes(recurrence.unit)) return false;
    return ["schedule", "complete"].includes(recurrence.trigger);
}

module.exports = { DONE_STATUS_TYPES, validateRecurrence };
